import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface preferencesUserState {
  loading: boolean;
  preferencesError: any | null;
  preferencesUser: any | null;
}

const initialState: preferencesUserState = {
  loading: false,
  preferencesError: null,
  preferencesUser: null,
};

const preferencesUserSlice = createSlice({
  name: 'preferenceUser',
  initialState,
  reducers: {
    // fetch generate code for device status
    preferencesUserRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.preferencesError = null;
    },
    preferencesUserSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.preferencesUser = action.payload;
      state.preferencesError = null;
    },
    preferencesUserFailure(state, action: PayloadAction<any>) {
      state.loading = false;
      state.preferencesError = action.payload;
    },
    resetPreferencesUserSlice(state) {
      return initialState; // Reset the slice to its initial state
    },
  },
});

export const {
  preferencesUserRequest,
  preferencesUserSuccess,
  preferencesUserFailure,
  resetPreferencesUserSlice,
} = preferencesUserSlice.actions;

export default preferencesUserSlice.reducer;
